import React from 'react';
import { catHaiChuSo } from '../../utils/dinhDangSo';
import { nguongQuangDuong, trangThaiQuangDuong } from '../../utils/nguongQuangDuong';

/**
 * Ô "Tổng QĐ" — chỗ duy nhất trong giao diện này được phép mạnh tay.
 *
 * Câu hỏi của mỗi dòng là nhị phân: đủ quãng đường luật định hay chưa. Trước
 * đây ô chỉ hiện `805,67 km` và bắt người đọc tự nhớ ngưỡng của từng hạng —
 * BSS 810, BTĐ 710, C1 825 — trong một bảng trộn lẫn nhiều khoá. Giờ ngưỡng
 * nằm ngay cạnh con số.
 *
 * Ba quy tắc, mỗi cái có lý do:
 *   - `catHaiChuSo` chứ không phải `toFixed(2)`: cắt, không làm tròn. Quãng
 *     đường đã đạt không được phép hiện nhiều hơn thực tế.
 *   - Dấu ✓ / ◦ luôn đi kèm màu. Người không phân biệt được màu vẫn đọc được,
 *     và ảnh chụp đen trắng vẫn dùng được.
 *   - Không tra được hạng thì không tô màu, không bịa ngưỡng — hiện con số trần
 *     đúng như cũ.
 */
export default function OQuangDuong({ value, data }) {
  const khoa = data?.courseShortName;
  const km = catHaiChuSo(value);
  const nguong = nguongQuangDuong(khoa);
  const trangThai = trangThaiQuangDuong(value, khoa);

  if (nguong == null) {
    return <span className='dat-km'>{value ? `${km} km` : ''}</span>;
  }

  const dat = trangThai === 'dat';
  return (
    <span
      className={`dat-km ${dat ? 'dat-km--pass' : 'dat-km--short'}`}
      title={dat ? 'Đã đủ quãng đường' : `Còn thiếu ${catHaiChuSo(nguong - km)} km`}
    >
      {km}
      <span className='dat-km__threshold'> / {nguong}</span>
      {' '}
      {dat ? '✓' : <span className='dat-km__mark--wait' aria-hidden='true' />}
      <span className='visually-hidden'>{dat ? ' đã đủ' : ' chưa đủ'}</span>
    </span>
  );
}
